<template>
  <div class="router-link-button">
    <RouterLink :to="to">
      <FormButton>
        <slot></slot>
      </FormButton>
    </RouterLink>
  </div>
</template>

<script lang="ts" setup>
import FormButton from '@/components/common/FormButton.vue'

defineProps({
  to: {
    type: Object,
    required: true,
  },
})
</script>
